'use strict';

import $ from 'jquery';

$('#display_info').on('click', openNav);

function setTransform(elem, transform) {
    ['-webkit-transform', '-moz-transform', '-ms-transform', '-o-transform', 'transform'].forEach(descriptor => {
        elem.css(descriptor, transform);
    });
}

function openNav() {
    $('#display_info').off('click');
    $('#display_info').on('click', closeNav);
    setTransform($('#sidenav, #main, #footer'), 'translateX(100%)');
}

function closeNav() {
    $('#display_info').off('click');
    $('#display_info').on('click', openNav);
    setTransform($('#sidenav, #main, #footer'), 'translateX(0)');
}